import DemoWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
